<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import Button from '@components/Button.svelte';
  import EmbeddedPostAjax from '@ajax/embedded_posts';
  import PreloadBox from '@components/PreloadBox.svelte';
  import Carousel from '@app-components/modal/embed_posts/Carousel.svelte';
  import RemovePost from '@app-components/modal/embed_posts/RemovePost.svelte';
  import { getGlobalStore } from '@stores/global';
  import Notification from '@utils/notification';
  import Track from '@utils/track';
  import { browser } from '$app/environment';
  let globalStateStore = getGlobalStore('globalStateStore');
  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let currentUser = null;
  export let group = null;
  let dataLoaded = false;
  let editorLoading = false;
  let errorMessage = null;
  let buttonDisabled = true;
  let link = null;
  let embeddedPostId = null;
  let waitState = null;
  let lastSearchedValue = null;

  let postInformation = null;
  let loadData = async function () {
    const response = await EmbeddedPostAjax.getPosts(group);
    postInformation = response.embedded_posts[0];
    dataLoaded = true;
  };
  if (browser) {
    loadData();
  }
  let showPreFillBox = false;
  let pollForInformation = async function () {
    postInformation = await EmbeddedPostAjax.getPostById(group, embeddedPostId);
    if (postInformation.status == 'queued') {
      setTimeout(pollForInformation, 500);
    } else {
      waitState = null;
      globalStateStore.set({ postEmbedded: true });
      Notification.send({
        text: 'Post successfully added to list!',
        layout: 'bottomLeft',
      });
    }
  };

  // Start the loop
  let submitEmbedPost = async function () {
    let response = await EmbeddedPostAjax.create(group, link);
    embeddedPostId = response.id;
    if (embeddedPostId) {
      pollForInformation();
    }
  };

  let handleSubmit = async function () {
    if (!buttonDisabled) {
      submitEmbedPost();
      Track.embedPostImported({ currentUser: currentUser, group: group, link: link });
      waitState = 'finding-post';
      setTimeout(() => {
        if (postInformation == null || postInformation.status == 'queued') {
          waitState = 'embedding-post';
        }
      }, 1000);
    }
  };

  let handleValueChange = async function () {
    lastSearchedValue = link;
    if (link == '' || link == null || link === undefined) {
      buttonDisabled = true;
      errorMessage = null;
    } else {
      editorLoading = true;
      let response = await EmbeddedPostAjax.validateLink(link);
      editorLoading = false;
      if (response.valid) {
        buttonDisabled = false;
        errorMessage = null;
        handleSubmit();
      } else {
        errorMessage = response.error_message;
        buttonDisabled = true;
      }
    }
  };

  let handlePaseEvent = async function () {
    setTimeout(() => {
      if (mobile) {
        const firstInput = document.getElementsByName('embed-post-link-input')[0];
        if (firstInput) {
          const currentValue = firstInput.value;
          if (currentValue != lastSearchedValue) {
            link = firstInput.value;
            handleValueChange();
          }
        }
      }
    }, 200);
  };
  let handleCloseButtonClick = function () {
    dispatch('back-button-click');
  };
  let handleBackButtonClick = async function () {
    if (postInformation) {
      link = null;
      postInformation = null;
    } else {
      dispatch('back-button-click');
    }
  };
  let showDeletePostAlert = false;
  let handleDeletePost = async function () {
    showDeletePostAlert = false;
    EmbeddedPostAjax.delete(group, postInformation.id);
    Track.embedPostRemoved({ currentUser: currentUser, group: group, link: postInformation.url });

    link = null;
    postInformation = null;
    globalStateStore.set({ embeddedPostDeleted: true });
  };
  let handleDeletePostCancel = function () {
    showDeletePostAlert = false;
  };
  let handleRemoveButtonClick = function () {
    showDeletePostAlert = true;
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
  * :global(.embed_posts-modal__container-mobile) {
    width: calc(100% - 20px) !important;
    padding: 0px !important;
  }

  * :global(.embed_posts-modal__container-desktop) {
    padding: 0px !important;
    width: 492px !important;
  }

  * :global(.modal__content) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  * :global(.input-container) {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 24px;
  }

  // * :global(.embed_posts-modal__container-desktop) {
  //   max-width: 640px !important;
  // }
  // * :global(.embed_posts-modal__container-mobile) {
  //   width: calc(100% - 20px) !important;
  // }
  .content-container.mobile {
    .main-content {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }

  .content-container.information {
    gap: 63px !important;
    height: 735px !important;
    justify-content: space-between;
  }
  .content-container.information.mobile {
    height: 570px !important;
    gap: 32px !important;
    justify-content: space-between;
    .delete-button-container {
      width: calc(100% - 32px) !important;
    }
  }
  .content-container.embedding.mobile {
    height: 570px !important;
    justify-content: space-between;
    padding-top: 100px;
    gap: 80px;
  }
  .content-container.embedding {
    display: flex;
    width: 100%;
    padding-top: 257px;
    flex-direction: column;
    height: 735px !important;
    justify-content: space-between;
    align-items: center;
    gap: 217px;
    .main-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 88px;
      .top-wand {
        width: 66px;
        height: 66px;
        background: url('/images/embed-posts/wand.png');
        background-size: contain;
        animation: waveWand 1.2s ease-in-out infinite alternate;
      }
      @keyframes waveWand {
        0% {
          transform: rotate(-5deg);
        }
        100% {
          transform: rotate(90deg);
        }
      }
      .text-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        .spinner {
          width: 20px;
          height: 20px;
          background: url('/images/embed-posts/Spinner.svg');
          background-size: contain;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .text {
          color: #717171;
          text-align: center;
          font-size: 22px;
          font-style: normal;
          font-weight: 900;
          line-height: 28px; /* 127.273% */
          letter-spacing: -0.5px;
        }
      }
    }
    .bottom-content {
      color: #717171;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
    }
  }

  .content-container {
    display: flex;
    flex-direction: column;
    padding-bottom: 36px;
    align-items: center;
    gap: 44px;
    .hidden-carousel {
      display: none;
    }
    .top-header {
      display: flex;
      width: 100%;
      height: 60px;
      padding: 20px 24px;
      justify-content: center;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ececec;
      .header-icon {
        cursor: pointer;
        &:hover {
          path {
            fill: #d5cfea;
          }
        }
      }
      .header-text {
        color: #1c1c1c;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
    .main-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 40px;
      padding-right: 40px;
      .content-header {
        color: #717171;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
      .finished-btn {
        width: 100%;
      }
    }
    .delete-button-container {
      display: flex;
      width: 343px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1 0 0;
      border-radius: 12px;
      border: 1px solid #ff5567;
      background: #fff;
      cursor: pointer;
      color: #e82c3f;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 171.429% */
      padding: 12px;
      max-height: 48px;
      opacity: 1;
      &:hover {
        opacity: 0.75;
      }
    }
  }
</style>

<RemovePost
  mobile={mobile}
  on:yes-click={handleDeletePost}
  on:cancel={handleDeletePostCancel}
  bind:show={showDeletePostAlert} />
{#if dataLoaded}
  <div class="svelte-modal svelte-embed_posts-modal">
    <Modal
      on:close={() => {
        dispatch('close');
      }}
      show={showModal}
      showCloseButton={false}
      fadeInDuration={0}
      closeOnOverlayClick={false}
      containerClass="embed_posts-modal__container-{mobile ? 'mobile' : 'desktop'}">
      <div
        slot="content"
        class="content-container {mobile ? 'mobile' : 'desktop'} {waitState
          ? 'embedding'
          : postInformation
            ? 'information'
            : ''}">
        {#if waitState}
          <div class="main-content">
            <div class="top-wand"></div>
            <div class="text-container">
              <div class="spinner"></div>
              <div class="text">
                {#if waitState == 'finding-post'}
                  FINDING POST...
                {:else}
                  EMBEDDING...
                {/if}
              </div>
            </div>
          </div>
          <div class="bottom-content">Hang in there, this will only <br />take a few seconds</div>
        {:else}
          <div class="top-header">
            <div class="back-button header-icon" on:click|preventDefault|stopPropagation={handleBackButtonClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.41113 11.4351C9.6763 11.0639 9.63331 10.5122 9.3151 10.2028L5.5065 6.5L9.3151 2.79721C9.63331 2.48784 9.6763 1.9361 9.41113 1.56486C9.14596 1.19362 8.67303 1.14346 8.35482 1.45283L3.85482 5.82781C3.68383 5.99405 3.58496 6.24032 3.58496 6.5C3.58496 6.75968 3.68383 7.00595 3.85482 7.17219L8.35482 11.5472C8.67303 11.8565 9.14595 11.8064 9.41113 11.4351Z"
                  fill="#AE94F9" />
              </svg>
            </div>
            <div class="header-text">Embed post</div>
            <div class="close-button header-icon" on:click|preventDefault|stopPropagation={handleCloseButtonClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path
                  d="M3.95338 2.25736C3.50848 1.81246 2.78715 1.81246 2.34225 2.25736C1.89735 2.70226 1.89735 3.42359 2.34225 3.86849L4.97376 6.5L2.34225 9.13151C1.89735 9.57641 1.89735 10.2977 2.34225 10.7426C2.78715 11.1875 3.50848 11.1875 3.95338 10.7426L6.58489 8.11113L9.2164 10.7426C9.6613 11.1875 10.3826 11.1875 10.8275 10.7426C11.2724 10.2977 11.2724 9.57641 10.8275 9.13151L8.19602 6.5L10.8275 3.86849C11.2724 3.42359 11.2724 2.70226 10.8275 2.25736C10.3826 1.81246 9.6613 1.81246 9.2164 2.25736L6.58489 4.88887L3.95338 2.25736Z"
                  fill="#AE94F9" />
              </svg>
            </div>
          </div>
          {#if postInformation}
            {#if showPreFillBox}
              <PreloadBox style="width: calc(100% - 32px);" />
            {:else}
              <Carousel
                items={postInformation.media_items}
                postInformation={postInformation}
                mobile={mobile}
                group={group}
                user={currentUser}>
              </Carousel>
              <div class="delete-button-container" on:click|preventDefault|stopPropagation={handleRemoveButtonClick}>
                <div class="delete-button">Remove</div>
              </div>
            {/if}
          {:else}
            <div class="main-content">
              <div class="content-header">
                Paste the direct link of your Instagram or TikTok post to embed it at the top of this list.
              </div>

              <Input
                focus={true}
                label={null}
                name="embed-post-link-input"
                bind:value={link}
                bind:loading={editorLoading}
                error={errorMessage}
                placeholder="Post link"
                customErrorEvent={true}
                on:change={handleValueChange}
                on:paste={() => {
                  handlePaseEvent();
                }}
                on:close_icon_clicked={() => {
                  buttonDisabled = true;
                  errorMessage = null;
                  link = '';
                  lastSearchedValue = '';
                }} />
              <div class="finished-btn">
                <Button disabled={buttonDisabled} style="margin: 0;" text={'Import'} on:click={handleSubmit} />
              </div>
            </div>
          {/if}
        {/if}
      </div>
    </Modal>
  </div>
{/if}
